import type { SVGProps } from "react";
const SvgTextAlignCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#191B20" d="M5 9v1.5h10V9zm0 4.5V15h10v-1.5zM3 4.75v1.5h14v-1.5z" />
  </svg>
);
export default SvgTextAlignCenter;
